/* eslint-disable react-hooks/exhaustive-deps */

import { Form } from "@renderbus/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useForm from "antd/es/form/hooks/useForm";
import { ModalStyle, RechargeForm } from "./atom";
import { Input, Modal, ModalType } from "task-eva-ui";
import { initVerifyRechargeInfo, usePictureTopUpStore } from "../../store";
import { useToastStore } from "@/store/toast-store";

export function RechargeVoucher() {
  const { t } = useTranslation("topup");
  const m1 = t("coupon_rule_first");
  const m2 = t("renderbus_coupon_code_rule_tips");
  const { setter: setPictureTopUpStore } = usePictureTopUpStore();
  const inputCode = usePictureTopUpStore((state) => state.inputCode);
  const verifyRechargeCode = usePictureTopUpStore(
    (state) => state.verifyRechargeCode
  );
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const { showGlobalToast } = useToastStore();
  const showCouponCodeModal = usePictureTopUpStore(
    (state) => state.showCouponCodeModal
  );
  const amount = usePictureTopUpStore((state) => state.amount);

  const onInput = (val: any) => {
    setPictureTopUpStore({ inputCode: val });
    form.setFieldValue("inputCode", val);
  };

  const verifyCode = () => {
    setLoading(true);
    form
      .validateFields()
      .then(async () => {
        const couponNO = form.getFieldValue("inputCode");
        const { code, data } = await verifyRechargeCode({
          couponNO,
          amount: Number(amount),
        });
        setLoading(false);
        if (code === 200) {
          setPictureTopUpStore({
            verifyRechargeInfo: data,
          });
          showGlobalToast({
            type: "success",
            content: t("renderbus_coupon_code_tips_200"),
          });
        } else {
          setPictureTopUpStore({
            verifyRechargeInfo: initVerifyRechargeInfo,
          });
          showGlobalToast({
            type: "error",
            content: t(`renderbus_coupon_code_tips_${code}`),
          });
        }
        form.resetFields(["inputCode"]);
        setPictureTopUpStore({ showCouponCodeModal: false, inputCode: "" });
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  const handleClose = () => {
    form.resetFields(["inputCode"]);
    setPictureTopUpStore({ showCouponCodeModal: false, inputCode: "" });
  };

  useEffect(() => {
    if (showCouponCodeModal) {
      form.setFieldValue("inputCode", inputCode || "");
    }
  }, [showCouponCodeModal, inputCode, form]);
  return (
    <div>
      <Modal
        type={ModalType.Confirm}
        open={showCouponCodeModal}
        title={t("renderbus_recharge_redemption_code")}
        submitting={loading}
        onClose={handleClose}
        onOk={verifyCode}
        confirmText={t("renderbus_coupon_code_add")}
        children={
          <RechargeForm form={form}>
            <div>{t("renderbus_redemption_code")}</div>
            <Form.Item
              name="inputCode"
              rules={[
                { required: true, message: m1 },
                {
                  pattern: new RegExp(/^[0-9a-zA-Z]{4,18}$/, "g"),
                  message: m2,
                },
              ]}
            >
              <div className="picture-coupon-code-input">
                <Input
                  value={inputCode}
                  background="#212327"
                  onInput={(e) => onInput?.(e.currentTarget.value)}
                  placeholder={t("renderbus_coupon_code_btn")}
                />
              </div>
            </Form.Item>
          </RechargeForm>
        }
      />
      <ModalStyle />
    </div>
  );
}
